import { editTableTypes } from '../constants/edittableConstants';

const initialState = {
    opened: false,
    data: null,
    callback: () => {},
    openedTemplate: false,
    callbackTemplate: () => {}
};

export const editTableReducer = (state = initialState, action) => {
    switch (action.type) {
        case editTableTypes.OPEN_CLOSE_WINDOW:
            return {
                ...state,
                opened: action.opened,
                callback: action.callback ? action.callback : (() => {}),
                data: action.data
            };

        case editTableTypes.OPEN_CLOSE_TEMPLATE_WINDOW:
            return {
                ...state,
                openedTemplate: action.openedTemplate,
                callbackTemplate: action.callbackTemplate ? action.callbackTemplate : (() => {})
            };

        case editTableTypes.SET_DATA:
            return {
                ...state,
                data: action.data
            };

        case editTableTypes.RESET:
            return {
                ...state,
                ...initialState
            };

        default:
            return state;
    }
};